"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceStatusArray = void 0;
exports.deviceStatusArray = [
    { label: '正常', value: 0 },
    { label: '已损坏', value: 1 },
];
